// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iwstud5R20cSA7sa0kin{margin-bottom:40px}.F6gn3TUC6CpxNpAEg0C4{border-bottom:1px solid #e9e9e9;margin-bottom:20px;padding-bottom:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scheduleAppointmentListSubtitle": `iwstud5R20cSA7sa0kin`,
	"emptyAppointmentList": `F6gn3TUC6CpxNpAEg0C4`
};
module.exports = ___CSS_LOADER_EXPORT___;
